import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import { useStore } from 'mobx-store-provider';
import * as React from 'react';
import styled from 'styled-components';

import { FilterTag } from '../DesignSystemV2/FilterTag';
import { Typography } from '../DesignSystemV2/Typography';
import { FilterMobileStore } from './store/filter-mobile.store';
import { FilterStore } from './store/filter.store';

interface SelectedFiltersProps extends React.HTMLAttributes<HTMLDivElement> {
  model: typeof FilterStore | typeof FilterMobileStore;
  hideOnEmpty?: boolean;
}

const Main = styled.div`
  .selected-filter-list {
    display: flex;
    flex-wrap: wrap;
    margin: -6px;
    > * {
      margin: 6px;
    }
  }
  .btn-clear {
    display: grid;
    place-items: center;
    height: 40px;
    cursor: pointer;
  }
`;

export const SelectedFilters = observer((props: SelectedFiltersProps) => {
  const { model, hideOnEmpty = true, ...rest } = props;
  const store = useStore(model);

  if (!store) return null;

  const { selectedCount, visibleGroupWithoutSort, clearFilter } = store;

  if (!selectedCount && hideOnEmpty) return null;

  return (
    <Main {...rest}>
      <div className="selected-filter-list">
        {visibleGroupWithoutSort.map((group, index) =>
          !isNil(group.selectedOption) && !group.selectedOption.hidden ? (
            <FilterTag
              key={group.uuid || index}
              onClose={() => group.setSelectedValue(undefined)}
              text={group.selectedOption.label}
            />
          ) : null
        )}

        <div onClick={clearFilter} className="btn-clear">
          <div>
            <Typography.Text height={40} color="blue100" variant="semi-bold/14">
              Xóa tất cả
            </Typography.Text>
          </div>
        </div>
      </div>
    </Main>
  );
});
